import { Button } from '@wordpress/components';
import { useSettings } from '../App/CartContext';

const CartOpenButton = ({ onOpenCart }) => {
    const {
        settings,
        basketIconSvg,
        svgImg,
        cart,
    } = useSettings();

    const plugin_enabled = settings?.atc_enable === 'true';
    const plugin_enabled_mobile = settings?.mobile_en === 'true';
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    if (!plugin_enabled) return null;
    
    if (isMobile && !plugin_enabled_mobile) return null;

    if (PSCFW_GLOBALS.hide_cart_ui) return null;

    return (
        <div
            className={`cart-wrapper position-${settings?.basekt_position} shape-${settings?.basekt_shape}`}
            style={{
                '--basket-bg': settings?.basket_bg_color,
                '--basket-color': settings?.basket_color,
                '--basket-x': `${settings?.basket_down_offset}px`,
                '--basket-y': `${settings?.basket_up_offset}px`,
            }}
        >
            <Button className="cart-open-btn" style={{ '--cart-icon-size': settings?.basket_size + 'px' }} onClick={onOpenCart} >
                {svgImg ? (
                    <img src={svgImg} width={settings?.basket_size + 'px'} alt="Cart" />
                ) : basketIconSvg ? (
                    <span
                        className="cart-btn-icon"
                        dangerouslySetInnerHTML={{ __html: basketIconSvg }}
                    />
                ) : null}
            </Button>

            {settings?.show_product_count === 'true' &&
                <span
                    className={`product-count-badge position-${settings?.basket_count_position}`}
                    style={{
                        backgroundColor: settings?.count_bg_color,
                        color: settings?.count_text_color,
                    }}
                >
                    {settings?.backet_product_count === 'count_quantity' ? (cart?.count || 0) : (cart?.prdCount || 0)}
                </span>
            }
        </div>
    );
};

export default CartOpenButton;
